import {
  ERROR_PRIVILEGE,
  LOADING_PRIVILEGE,
  LOG_OUT,
  RESET_AUTH,
  SUCCESS_PRIVILEGE,
} from '../../const/actionTypes';
import { GET_EXTERNAL_USER_BY_ACCESS_TOKEN } from '../../const/URL';
import axiosInstance from '../../services/axiosInstance';

export const logout = () => {
  return (dispatch: any) => {
    localStorage.removeItem('enterprise_portal_access_Token');
    localStorage.removeItem('enterprise_portal_refresh_token');
    localStorage.removeItem('selectedCusRef');
    window.location.reload();
    dispatch({
      type: LOG_OUT,
    });
  };
};

export const getPrivileges = (): any => {
  // let formData = new FormData()

  // formData.append('username', 'damith')
  // formData.append('password', 'abc123')

  return (dispatch: any) => {
    dispatchAction(dispatch, LOADING_PRIVILEGE);
    axiosInstance
      .get(GET_EXTERNAL_USER_BY_ACCESS_TOKEN)
      .then((response: any) => {
        if (response.status === 200) {
          // console.log(response.data.dataBundle.customer.references[0].code)
          if (response.data.dataBundle.customer.references.length > 0) {
            const CusRef = Array.from(
              new Set(
                response.data.dataBundle.customer.references.flatMap((x: any) =>
                  x.code.split(', ')
                )
              )
            ).toString();
            // console.log(CusRef)
            localStorage.setItem('selectedCusRef', CusRef);
          } else {
            localStorage.setItem('selectedCusRef', '0');
          }

          dispatchAction(dispatch, SUCCESS_PRIVILEGE, response.data.dataBundle);
        } else {
          dispatchAction(dispatch, ERROR_PRIVILEGE, 'Login failed');
        }
      })
      .catch(() => {
        dispatchAction(dispatch, ERROR_PRIVILEGE, 'Login failed');
      });
    // dispatchAction(dispatch, SUCCESS_PRIVILEGE,' response.data.dataBundle')
  };
};

export const resetAuth = () => (dispatch: any) => {
  dispatchAction(dispatch, RESET_AUTH);
};

function dispatchAction(dispatch: any, type: string, payload?: {}) {
  dispatch({
    type: type,
    payload: payload,
  });
}
